import React from "react";

import { graphql } from "gatsby";

import DonorArticleEmbed from "./donorArea/donorArticleEmbed";
import DonorTopicEmbed from "./donorArea/donorTopicEmbed";
import KontentItemVideoEmbed from "./kontentItemVideoEmbed";
import LearnArticleEmbed from "./learn/learnArticleEmbed";
import LearnTopicEmbed from "./learn/learnTopicEmbed";
import IconButton from "../components/button/iconButton";
import LinkButton from "../components/button/linkButton";
import LearnEmbedModule from "../components/learnEmbedModule/learnEmbedModule";
import { ReactComponent as IconFurther18 } from "../icons/icon/18/a-icon-further-18.svg";

interface KontentItemRelatedLearnContentEmbedProps {
  data: Queries.kontent_item_related_learn_content_embed;
}

const KontentItemRelatedLearnContentEmbed: React.FC<KontentItemRelatedLearnContentEmbedProps> = ({ data }) => {
  if (!data || !data.elements) {
    return null;
  }

  const elements = data.elements!;

  return (
    <LearnEmbedModule
      headline={elements.headline?.value || ""}
      buttonLearnArea={(
        <IconButton
          href={
            (elements.button_learn_area?.value?.length ?? 0) > 0
              ? elements.button_learn_area?.value?.[0]?.id
              : "#"
          }
          variant="plain-learn-area"
        >
          {elements.button_text?.value}
        </IconButton>
      )}
      buttonDonorArea={
        elements.button_text_donor_area?.value !== ""
          ? (
            <LinkButton
              href={
                (elements.button_donor_area?.value?.length ?? 0) > 0
                  ? elements.button_donor_area?.value?.[0]?.id
                  : "#"
              }
            >
              {elements.button_text_donor_area?.value}
              <IconFurther18 />
            </LinkButton>
          )
          : null
      }
      subHeadlineDonorArea={elements.sub_headline_donor_area?.value || ""}
    >
      {elements.article___video_cards?.value?.map((item) => {
        if (item && item.id) {
          switch (item.internal.type) {
            case "kontent_item_video_embed":
              return <KontentItemVideoEmbed key={item.id} data={item as Queries.kontent_item_video_embed} variant="learn-module" ltr noLength />;
            case "kontent_item_article_page_learn":
              return <LearnArticleEmbed data={item as Queries.kontent_item_article_page_learn} key={item.id} />;
            case "kontent_item_learn_topics_page":
              return <LearnTopicEmbed data={item as Queries.kontent_item_learn_topics_page} key={item.id} />;
            case "kontent_item_donor_area_topic":
              return <DonorTopicEmbed data={item as Queries.kontent_item_donor_area_topic} key={item.id} />;
            case "kontent_item_article_donor_area":
              return <DonorArticleEmbed data={item as Queries.kontent_item_article_donor_area} key={item.id} />;
            default:
          }
        }

        return null;
      })}
    </LearnEmbedModule>
  );
};

export const query = graphql`
  fragment KontentItemRelatedLearnContentEmbed on kontent_item_related_learn_content_embed {
    id
    system {
      codename
    }
    elements {
      headline {
        value
      }
      article___video_cards {
        value {
          internal {
            type
          }
          ...KontentItemVideoEmbed
          ...LearnArticleEmbed
          ...LearnTopicEmbed
          ...DonorTopicEmbed
          ...DonorArticleEmbed
        }
      }
      button_text {
        value
      }
      sub_headline_donor_area {
        value
      }
      button_text_donor_area {
        value
      }
      button_learn_area {
        value {
          id
        }
      }
      button_donor_area {
        value {
          id
        }
      }
    }
  }
`;

export default KontentItemRelatedLearnContentEmbed;
